import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Module } from '@core/configs/role';
import { RoleGuard } from '@core/guards/role.guard';
import * as R from '__route';
import { AuthGuard } from '~/app/core/guards/auth.guard';
import { MainLayoutComponent } from '~/app/shared/layouts/main-layout/main-layout.component';
import { DashboardComponent } from './main-dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        pathMatch: 'full',
        children: [],
      },
    ],
  },
  {
    path: 'alerts',
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./alert/alert.module').then((m) => m.AlertModule),
    canActivate: [AuthGuard],
  },
  {
    path: R.REQUEST_P,
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./requests/request.module').then((m) => m.RequestsModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {module_id: Module.REQUEST}
  },
  {
    path: R.PHYSICAL_TRANSPORT_P,
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./physical-transport/physical-transport.module').then((m) => m.PhysicalTransportModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { module_id: Module.PHYSICAL_TRANSPORT }
  },
  {
    path: R.INTERMODAL_P,
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./intermodal/intermodal.module').then((m) => m.IntermodalModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {module_id: Module.INTERMODAL}
  },
  {
    path: R.COMPLIANCE_P,
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./compliance/compliance.module').then((m) => m.ComplianceModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {module_id: Module.COMPLIANCE}
  },
  {
    path: R.ADMIN_P,
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { roleLogChainAdmin: false, module_id: Module.ADMIN },
  },
  {
    path: 'account',
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
    canActivate: [AuthGuard],
  },
  {
    path: R.LCADMIN_P,
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { roleLogChainAdmin: true, module_id: Module.LOGCHAIN },
  },
  {
    path: R.REGULATORY_P,
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./regulatory-dashboard/regulatory.module').then((m) => m.RegulatoryModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { module_id: Module.REGULATORY },
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
